import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/http.service';

import { EndpointParams } from '@models/utils/endpoint-params';
import { BooleanDto } from '@models/basic/boolean-dto';

@Injectable({
    providedIn: 'root'
})
export class MailService extends HttpService {

    private readonly defaultEndpointParams: EndpointParams = { app: 'notification', version: 1 };

    validateMail(email: string): Observable<BooleanDto>{
        return this.post('notifications/email/validate', this.defaultEndpointParams, {value : email});
    }
}
